export default __webpack_public_path__ + "static/char-s-58-ko-c592d40dc61a543ee10dbd4c1b1cbd61.webp";